angular.module('taric.measure.amendments', ['taric.model.measureAmendments', 'common.filter.commoditycode', 'common.model.measuretype', 'taric.auth.model'])
    .controller('MeasureAmendmentsController', function (CONSTANTS, $translatePartialLoader, MeasureAmendmentsModel, MeasureTypeModel, AuthorizeModel, CommonHelper, measureTypes, $state, $stateParams, $rootScope, $scope, $filter, $timeout, $translate, $location) {
        var measureAmendmentsCtrl = this;

        measureAmendmentsCtrl.init = function () {
            measureAmendmentsCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            measureAmendmentsCtrl.dateFormat = CONSTANTS.dateFormat;
            measureAmendmentsCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
            measureAmendmentsCtrl.installationCountry = CONSTANTS.installationCountry;
            measureAmendmentsCtrl.searchCriteria = MeasureAmendmentsModel.getSearchCriteria();
            measureAmendmentsCtrl.searchResult = MeasureAmendmentsModel.getSearchResult();
            measureAmendmentsCtrl.measureTypes = measureTypes;
            measureAmendmentsCtrl.loadUpdateTypes();
            MeasureAmendmentsModel.loggedIn = AuthorizeModel.loggedIn;

            // get valid MeasureType
            if (measureTypes) {
                measureAmendmentsCtrl.searchCriteria.measureType = CommonHelper.getValidSelectedItem(
                    measureTypes.items,
                    measureAmendmentsCtrl.searchCriteria.measureType,
                    null);
            }

            if (measureAmendmentsCtrl.isExternalLink() && measureAmendmentsCtrl.validateExternalParameters()) {
                // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
                measureAmendmentsCtrl.loadDataFromServerWithoutValidation(1);
            }
        };

        measureAmendmentsCtrl.isExternalLink = function(){
            // Verify 'frm' parameter to avoid auto-search after looking up commodity code, additional code, footnote, or certificate.
            return (!$stateParams.frm || $stateParams.frm !== 'ccLookup' || $stateParams.frm !== 'adcoLookup' ||
                $stateParams.frm !== 'footnoteLookup' || $stateParams.frm !== 'certificateLookup') &&
                $stateParams.ds && $stateParams.ccs && $stateParams.d && $stateParams.mt && $stateParams.l;
        };

        // Check whether the external parameters are valid or not
        measureAmendmentsCtrl.validateExternalParameters = function(){
            return measureAmendmentsCtrl.validateSearchForm();
        };

        measureAmendmentsCtrl.openStartDatePicker = function ($event) {
            measureAmendmentsCtrl.isStartDatePickerOpen = true;
        };
        measureAmendmentsCtrl.openEndDatePicker = function ($event) {
            measureAmendmentsCtrl.isEndDatePickerOpen = true;
        };

        measureAmendmentsCtrl.selectCommodityCodeRangeStart = function(commodityCode){
            measureAmendmentsCtrl.selectCommodityCode(commodityCode, measureAmendmentsCtrl.searchCriteria.startDate, "lookup", "commodityCodeRangeStart");
        };

        measureAmendmentsCtrl.selectCommodityCodeRangeEnd = function(commodityCode){
            measureAmendmentsCtrl.selectCommodityCode(commodityCode, measureAmendmentsCtrl.searchCriteria.startDate, "lookup", "commodityCodeRangeEnd");
        };

        measureAmendmentsCtrl.selectCommodityCode = function (commodityCode, date, type, ccField) {

            $state.go('taric.nomenclature.sbn', {
                cc: CommonHelper.removeSpaceCharacters(commodityCode),
                sd: CommonHelper.getBookmarkDateString(date),
                d: measureAmendmentsCtrl.searchCriteria.direction,
                frm: 'taric.report.measure',
                type: type,
                ccField: ccField
            });
        };

        measureAmendmentsCtrl.lookupAdditionalCode = function(additionalCode){
            $state.go('taric.adco.lookup', {
                frm: 'taric.report.measure',
                sd: CommonHelper.getBookmarkDateString(measureAmendmentsCtrl.searchCriteria.startDate),
                ad: CommonHelper.removeSpaceCharacters(additionalCode),
                mo: false
            });
        };

        measureAmendmentsCtrl.lookupFootnote = function(footnote){
            $state.go('taric.footnote.lookup', {
                frm: 'taric.report.measure',
                sd: CommonHelper.getBookmarkDateString(measureAmendmentsCtrl.searchCriteria.startDate),
                fo: CommonHelper.removeSpaceCharacters(footnote)
            });
        };

        measureAmendmentsCtrl.lookupCertificate = function(certificate){
            $state.go('taric.certificate.lookup', {
                frm: 'taric.report.measure',
                sd: CommonHelper.getBookmarkDateString(measureAmendmentsCtrl.searchCriteria.startDate),
                ce: CommonHelper.removeSpaceCharacters(certificate)
            });
        };

        // Reset error when user changes the additional code field
        measureAmendmentsCtrl.onChangeAdditionalCode = function(){
            measureAmendmentsCtrl.searchCriteria.additionalCode = measureAmendmentsCtrl.searchCriteria.additionalCode.toUpperCase();
            measureAmendmentsCtrl.handleError();
        };
        measureAmendmentsCtrl.onChangeFootnote = function(){
            measureAmendmentsCtrl.searchCriteria.footnote = measureAmendmentsCtrl.searchCriteria.footnote.toUpperCase();
            measureAmendmentsCtrl.handleError();
        };
        measureAmendmentsCtrl.onChangeCertificate = function(){
            measureAmendmentsCtrl.searchCriteria.certificate = measureAmendmentsCtrl.searchCriteria.certificate.toUpperCase();
            measureAmendmentsCtrl.handleError();
        };

        measureAmendmentsCtrl.search = function () {
            // Load data for the first page
            measureAmendmentsCtrl.loadDataFromServer(1);
        };

        //Load data for a given page
        measureAmendmentsCtrl.loadDataFromServer = function(page){
            if (!measureAmendmentsCtrl.validateSearchForm()){
                return;
            }

            measureAmendmentsCtrl.loadDataFromServerWithoutValidation(page);
        };

        //Load data for a given page without validation
        measureAmendmentsCtrl.loadDataFromServerWithoutValidation = function(page){
            // Reset search result before searching
            measureAmendmentsCtrl.resetSearchResult();
            measureAmendmentsCtrl.searching = true;

            MeasureAmendmentsModel.searchMeasureReport(page, measureAmendmentsCtrl.isNationalMeasureType(measureAmendmentsCtrl.searchCriteria.measureType)).then(function(searchResult) {
                measureAmendmentsCtrl.searchResult = searchResult;
                measureAmendmentsCtrl.searching = false;
                measureAmendmentsCtrl.updateBrowserURL();
            }, function(error){
                measureAmendmentsCtrl.errorCode = error.data.code;
                measureAmendmentsCtrl.errorParams = error.data.params;
                measureAmendmentsCtrl.errorType = error.data.type;
                measureAmendmentsCtrl.searching = false;

                if (measureAmendmentsCtrl.errorCode === 'i8n.bl.unauthenticated') {
                    $rootScope.$broadcast('tokenInvalid');
                }
            });
        };

        /**
         * Measure report
         * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/report/measure?ds={StartDate}&de={EndDate}
         * &ccs={CommodityCodeRangeStart}&cce={CommodityCodeRangeEnd}&d={TradeDirection}&mt={MeasureType}&ut={UpdateType}
         * &na={National}&ad={AdditionalCode}&fn={Footnote}&ce={Certificate}
         * &gnd={GoodsNomenclatureDescription}&add={AdditionalCodeDescription}&fnd={FootnoteDescription}&ced={CertificateDescription}&ded={DutyExpressionDescription}&l={Language}
         *
         * Example:
         * http://localhost:8080/arctictariff-public-web/#!/taric/report/measure?ds=2017-01-01&de=2017-01-31
         * &ccs=8001&cce=8414&d=I&mt=103&ut=D
         * &na=NATIONAL&ad=2500&fn=CD989&ce=Y949
         * &gnd=true&add=true&fnd=true&ced=true&ded=true&l=en
         */
        measureAmendmentsCtrl.updateBrowserURL = function(){
            if (!CONSTANTS.enableBookmark){
                return;
            }

            // Do not keep additional parameter 'frm' because there is no return to caller page
            $location.search({
                ds: CommonHelper.getBookmarkDateString(measureAmendmentsCtrl.searchCriteria.startDate),
                de: CommonHelper.getBookmarkDateString(measureAmendmentsCtrl.searchCriteria.endDate),
                ccs: CommonHelper.removeSpaceCharacters(measureAmendmentsCtrl.searchCriteria.commodityCodeRangeStart),
                cce: CommonHelper.removeSpaceCharacters(measureAmendmentsCtrl.searchCriteria.commodityCodeRangeEnd),
                d: measureAmendmentsCtrl.searchCriteria.direction,
                mt: measureAmendmentsCtrl.searchCriteria.measureType,
                ut: measureAmendmentsCtrl.searchCriteria.updateType,
                ad: measureAmendmentsCtrl.searchCriteria.additionalCode,
                fn: measureAmendmentsCtrl.searchCriteria.footnote,
                ce: measureAmendmentsCtrl.searchCriteria.certificate,
                gnd: measureAmendmentsCtrl.searchCriteria.goodsNomenclatureDescription.toString(),
                add: measureAmendmentsCtrl.searchCriteria.additionalCodeDescription.toString(),
                fnd: measureAmendmentsCtrl.searchCriteria.footnoteDescription.toString(),
                ced: measureAmendmentsCtrl.searchCriteria.certificateDescription.toString(),
                ded: measureAmendmentsCtrl.searchCriteria.dutyExpressionDescription.toString(),
                l : $translate.use()
            }).replace();
        };

        measureAmendmentsCtrl.resetSearchResult = function() {
            measureAmendmentsCtrl.searchResult = null;
        };

        measureAmendmentsCtrl.validateSearchForm = function(){
            measureAmendmentsCtrl.handleError();

            // Validate dates
            measureAmendmentsCtrl.errorCode = CommonHelper.validateSimulationDate(measureAmendmentsCtrl.searchCriteria.startDate);
            if (measureAmendmentsCtrl.errorCode) {
                measureAmendmentsCtrl.errorParams = {param0: CONSTANTS.pastDate};
                return false;
            }
            // Start date must be before or the same as end date
            if (CommonHelper.compareDatesWithoutTime(measureAmendmentsCtrl.searchCriteria.startDate, measureAmendmentsCtrl.searchCriteria.endDate) > 0){
                measureAmendmentsCtrl.errorCode = "i8n.common.invalidPeriod";
                return false;
            }
            // Max start date must be after end date. If end date is empty, today will be considered as end date
            if (CONSTANTS.menu.measureAmendments.maxIntervalInMonths) {
                var startDateMoment = moment(measureAmendmentsCtrl.searchCriteria.startDate, CONSTANTS.dateFormat.toUpperCase(), true);
                var maxStartDateMoment = moment(startDateMoment).add(CONSTANTS.menu.measureAmendments.maxIntervalInMonths, 'month');
                var endDate = measureAmendmentsCtrl.searchCriteria.endDate;
                if (!endDate) {
                    endDate = new Date();
                }
                if (CommonHelper.compareDatesWithoutTime(maxStartDateMoment.toDate(), endDate) <= 0){
                    measureAmendmentsCtrl.errorCode = "i8n.qry.report.measureAmendments.search.intervalLimit";
                    measureAmendmentsCtrl.errorParams = {number: CONSTANTS.menu.measureAmendments.maxIntervalInMonths};
                    return false;
                }
            }

            // Validate commodity codes
            if (!measureAmendmentsCtrl.searchCriteria.commodityCodeRangeStart){
                measureAmendmentsCtrl.errorCode = 'i8n.error.commodity.commodityCode.required';
                return false;
            }
            
            var ccRangeStart = CommonHelper.removeSpaceCharacters(measureAmendmentsCtrl.searchCriteria.commodityCodeRangeStart);
            var ccRangeEnd = CommonHelper.removeSpaceCharacters(measureAmendmentsCtrl.searchCriteria.commodityCodeRangeEnd);
            if (ccRangeStart !== "" && ccRangeEnd !== "" && ccRangeStart.localeCompare(ccRangeEnd) > 0){
                measureAmendmentsCtrl.errorCode = "i8n.qry.report.measureAmendments.search.commodityCodeRange.incorrect";
                return false;
            }
            measureAmendmentsCtrl.errorCode = CommonHelper.validateCommodityCode(measureAmendmentsCtrl.searchCriteria.commodityCodeRangeStart, measureAmendmentsCtrl.searchCriteria.direction);
            if (measureAmendmentsCtrl.errorCode){
                return false;
            }
            measureAmendmentsCtrl.errorCode = CommonHelper.validateCommodityCode(measureAmendmentsCtrl.searchCriteria.commodityCodeRangeEnd, measureAmendmentsCtrl.searchCriteria.direction);
            if (measureAmendmentsCtrl.errorCode){
                return false;
            }

            // Validate measure type
            if (!measureAmendmentsCtrl.searchCriteria.measureType){
                measureAmendmentsCtrl.errorCode = 'i8n.qry.report.measureAmendments.search.measureType.required';
                return false;
            }

            // Validate additional code
            if (CommonHelper.removeSpaceCharacters(measureAmendmentsCtrl.searchCriteria.additionalCode) !== "") {
                measureAmendmentsCtrl.errorCode = CommonHelper.validateAdditionalCode(measureAmendmentsCtrl.searchCriteria.additionalCode);
            }
            if (measureAmendmentsCtrl.errorCode){
                return false;
            }

            // Validate footnote
            if (CommonHelper.removeSpaceCharacters(measureAmendmentsCtrl.searchCriteria.footnote) !== "") {
                measureAmendmentsCtrl.errorCode = CommonHelper.validateFootnote(measureAmendmentsCtrl.searchCriteria.footnote);
            }
            if (measureAmendmentsCtrl.errorCode){
                return false;
            }

            // Validate certificate
            if (CommonHelper.removeSpaceCharacters(measureAmendmentsCtrl.searchCriteria.certificate) !== "") {
                measureAmendmentsCtrl.errorCode = CommonHelper.validateCertificate(measureAmendmentsCtrl.searchCriteria.certificate);
            }
            if (measureAmendmentsCtrl.errorCode){
                return false;
            }

            return true;
        };

        measureAmendmentsCtrl.searchResultPageChanged = function(page){
            measureAmendmentsCtrl.loadDataFromServerWithoutValidation(page);
        };

        measureAmendmentsCtrl.handleError = function(error) {
            if (!error) {
                measureAmendmentsCtrl.errorCode = null;
                measureAmendmentsCtrl.errorParams = null;
                measureAmendmentsCtrl.errorType = null;
            } else {
                measureAmendmentsCtrl.errorCode = error.errorCode;
                measureAmendmentsCtrl.errorParams = error.errorParams;
                measureAmendmentsCtrl.errorType = error.errorType;
            }
        };

        measureAmendmentsCtrl.onStartDateChange = function (dateString) {
            measureAmendmentsCtrl.searchCriteria.startDate = CommonHelper.formatDate(measureAmendmentsCtrl.searchCriteria.startDate, dateString);
            measureAmendmentsCtrl.handleError();
            measureAmendmentsCtrl.reloadMeasureTypes();
        };

        measureAmendmentsCtrl.onEndDateChange = function (dateString) {
            measureAmendmentsCtrl.searchCriteria.endDate = CommonHelper.formatDate(measureAmendmentsCtrl.searchCriteria.endDate, dateString);
            measureAmendmentsCtrl.onStartDateChange();
        };

        measureAmendmentsCtrl.reloadMeasureTypes = function () {
            if (!measureAmendmentsCtrl.searchCriteria.startDate ||
                    CommonHelper.compareDatesWithoutTime(measureAmendmentsCtrl.searchCriteria.startDate, measureAmendmentsCtrl.searchCriteria.endDate) > 0) {
                return;
            }

            MeasureTypeModel.getMeasureTypes(measureAmendmentsCtrl.searchCriteria.direction,
                                             measureAmendmentsCtrl.searchCriteria.startDate,
                                             measureAmendmentsCtrl.searchCriteria.endDate).then(function (measureTypes) {
                measureAmendmentsCtrl.measureTypes = measureTypes;
                measureAmendmentsCtrl.searchCriteria.measureType = CommonHelper.getValidSelectedItem(
                    measureTypes.items,
                    measureAmendmentsCtrl.searchCriteria.measureType,
                    null);
            });
        };

        measureAmendmentsCtrl.hasNationalMeasureTypes = function(){
            var nationalMeasureTypes = measureAmendmentsCtrl.measureTypes.items.filter(function(measureType){
                return measureType.national === true;
            });
            return nationalMeasureTypes.length > 0;
        };

        measureAmendmentsCtrl.isNationalMeasureType = function(measureTypeId){
            var nationalMeasureTypes = measureAmendmentsCtrl.measureTypes.items.filter(function(measureType){
                return measureType.national === true;
            });

            for (let i = 0; i < nationalMeasureTypes.length; i++) {
                if (nationalMeasureTypes[i].id === measureTypeId) {
                    return true;
                }
            }

            return false;
        };

        measureAmendmentsCtrl.loadUpdateTypes = function(){
            var updateTypeCodes = [
                "I",
                "U",
                "D"
            ];

            measureAmendmentsCtrl.updateTypes = [];
            updateTypeCodes.forEach(function(updateType){
                $translate("i8n.qry.report.measureAmendments.updateType.label." + updateType).then(function (updateTypeDescription){
                    measureAmendmentsCtrl.updateTypes.push({
                        "code": updateType,
                        "description": updateTypeDescription
                    });
                });
            });

            $timeout(function(){

                //Wait for the translation is done and then do a sort
                measureAmendmentsCtrl.updateTypes.sort(function (updateType1, updateType2) {
                    return updateType1.description.localeCompare(updateType2.description, CommonHelper.getLanguageCode($translate.use()));
                });
            }, 500);
        };
        
        // export pdf
        measureAmendmentsCtrl.print = function(options){
            if (!measureAmendmentsCtrl.validateSearchForm()){
                $scope.$apply();
                return;
            }

            $rootScope.$broadcast('startSpinningPrint');
            MeasureAmendmentsModel.searchMeasureReport(null, measureAmendmentsCtrl.isNationalMeasureType(measureAmendmentsCtrl.searchCriteria.measureType)).then(function (searchResult) {

                measureAmendmentsCtrl.searchAllResult = searchResult;
                setTimeout(function(){

                    // load documents
                    var doc = [];
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);
                    if (measureAmendmentsCtrl.searchAllResult.goodsNomenclatures) {
                        doc.push ({ text: '\n' });
                        CommonHelper.htmlTableToPdf(doc, document.getElementById('goodsNomenclatures'), options);
                    }
                    if (measureAmendmentsCtrl.searchAllResult.additionalCodes) {
                        doc.push ({ text: '\n' });
                        CommonHelper.htmlTableToPdf(doc, document.getElementById('additionalCodes'), options);
                    }
                    if (measureAmendmentsCtrl.searchAllResult.footnotes) {
                        doc.push ({ text: '\n' });
                        CommonHelper.htmlTableToPdf(doc, document.getElementById('footnotes'), options);
                    }
                    if (measureAmendmentsCtrl.searchAllResult.certificates) {
                        doc.push ({ text: '\n' });
                        CommonHelper.htmlTableToPdf(doc, document.getElementById('certificates'), options);
                    }

                    CommonHelper.printPlainDocument({
                        contents: doc,
                        logo: options.logo,
                        flag: measureAmendmentsCtrl.flagImg,
                        eu: measureAmendmentsCtrl.euImg,
                        validDate: $filter('date')(measureAmendmentsCtrl.searchCriteria.startDate, CONSTANTS.dateFormat),
                        title: $filter('translate')('i8n.qry.report.measureAmendments.title')
                    }, 'l').then(() => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    }, (error) => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    });
                }, 1000);
            }, function (error) {

                measureAmendmentsCtrl.errorCode = error.data.code;
                measureAmendmentsCtrl.errorParams = error.data.params;
                measureAmendmentsCtrl.errorType = error.data.type;
                $rootScope.$broadcast('stopSpinningPrint');

                if (measureAmendmentsCtrl.errorCode === 'i8n.bl.unauthenticated') {
                    $rootScope.$broadcast('tokenInvalid');
                }
            });
        };
        
    	$scope.$on('printDocument', function(event, data) {
            CommonHelper.loadImage("img/flags/EU.png", 21, 14, function(options) {

                measureAmendmentsCtrl.euImg = options.logo;
            }, true);

            var url = "img/flags/" + measureAmendmentsCtrl.installationCountry + ".png";
            CommonHelper.loadImage(url, 21, 14, function(options) {

                measureAmendmentsCtrl.flagImg = options.logo;
                CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, measureAmendmentsCtrl.print, true);
            }, true);
        });

        // export excel
        measureAmendmentsCtrl.exportExcel = function() {
            if (!measureAmendmentsCtrl.validateSearchForm()){
                $scope.$apply();
                return;
            }

            $rootScope.$broadcast('startSpinningExport');
            MeasureAmendmentsModel.searchMeasureReport(null, measureAmendmentsCtrl.isNationalMeasureType(measureAmendmentsCtrl.searchCriteria.measureType)).then(function (searchResult) {

                measureAmendmentsCtrl.searchAllResult = searchResult;
                setTimeout(function(){

                    var title = $filter('translate')('i8n.qry.report.measureAmendments.title');

                    // columns format of excel
                    var exportExcelTableId = "exportExcelTable";
                    var ws = {
                        '!cols': [{
                            wpx: 50
                        }, {
                            wpx: 100
                        }, {
                            wpx: 80
                        }, {
                            wpx: 100
                        }, {
                            wpx: 110
                        }, {
                            wpx: 250
                        }, {
                            wpx: 100
                        }, {
                            wpx: 90
                        }, {
                            wpx: 80
                        }]
                    };

                    if (!measureAmendmentsCtrl.searchCriteria.dutyExpressionDescription) {
                        exportExcelTableId = "exportExcelTableWithoutDutyExpression";
                        ws = {
                            '!cols': [{
                                wpx: 50
                            }, {
                                wpx: 100
                            }, {
                                wpx: 80
                            }, {
                                wpx: 100
                            }, {
                                wpx: 110
                            }, {
                                wpx: 100
                            }, {
                                wpx: 90
                            }, {
                                wpx: 80
                            }]
                        };
                    }

                    // export excel
                    CommonHelper.printExcel(exportExcelTableId, title, ws).then(() => {
                        $rootScope.$broadcast('stopSpinningExport');
                    }, () => {
                        $rootScope.$broadcast('stopSpinningExport');
                    });
                }, 1000);

            }, function (error) {

                measureAmendmentsCtrl.errorCode = error.data.code;
                measureAmendmentsCtrl.errorParams = error.data.params;
                measureAmendmentsCtrl.errorType = error.data.type;
                $rootScope.$broadcast('stopSpinningExport');

                if (measureAmendmentsCtrl.errorCode === 'i8n.bl.unauthenticated') {
                    $rootScope.$broadcast('tokenInvalid');
                }
            });
        };

        $scope.$on('exportDocument', function(event, data) {
            measureAmendmentsCtrl.exportExcel();
        });

        $rootScope.$on('$translateChangeSuccess', function () {

            //This is just a workaround to force the page to re-render the pagination items with translated texts
            measureAmendmentsCtrl.itemsPerPage = 99999999;
            $timeout(function(){
                measureAmendmentsCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            }, 100);
        });
    });


// WEBPACK FOOTER //
// ./app/taric/report/measureamendments/measure-amendments-search.js